import { createGlobalStyle } from 'styled-components';

export const TreeSelectorDropdownStyles = createGlobalStyle`
    .form-tree-selector-dropdown .ant-select-tree > div:first-of-type {
        height: 0;
        line-height: 0;
        overflow: hidden;
    }
`;
